import { useInterval } from "@chakra-ui/react"
import { useCallback, useState } from "react"
import { useEffectOnce } from "react-use"
import { usePrinticularApi } from "~/hooks/usePrinticularApi"
import { TemporaryCredentials } from "~/interfaces/entities/TemporaryCredentials"

export const usePrinticularMapTemporaryCredentials = () => {
  const api = usePrinticularApi()
  const [isReady, setIsReady] = useState(false)
  const [credentials, setCredentials] = useState<TemporaryCredentials>()

  const refreshCredentials = useCallback(async () => {
    const creds = await api.getTempCredentials()
    setCredentials(creds)
  }, [api])

  useEffectOnce(() => {
    refreshCredentials()
    setIsReady(true)
  })

  useInterval(async () => {
    refreshCredentials()
  }, 1000 * 60 * 40) // every 40 minutes (creds are valid for 1 hour)

  return { credentials, isReady }
}
